import AppConstants from "../appConstants";

// eslint-disable-next-line import/prefer-default-export
export const getAge = (dateOfBirth, dateToCalculate = new Date()) => {
  const dob = new Date(dateOfBirth).getTime();
  const dateToCompare = new Date(dateToCalculate).getTime();
  const age = (dateToCompare - dob) / (365 * 24 * 60 * 60 * 1000);
  return Math.floor(age);
};

export const checkIfMatchQueueFilterApplied = (currentUser) => {
  const { match_preferences: matchPreferences = {} } = currentUser;

  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;

    // Handle arrays
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      if (obj1.length !== obj2.length) return false;
      return obj1.every((val, i) => deepEqual(val, obj2[i]));
    }

    // Handle objects
    if (typeof obj1 === 'object' && obj1 !== null &&
      typeof obj2 === 'object' && obj2 !== null) {
      return Object.keys(obj1).every(key => deepEqual(obj1[key], obj2[key]));
    }

    return false;
  }

  // Build a filtered object with only the keys from MATCH_QUEUE_FILTERS
  const filteredPreferences = Object.keys(AppConstants.MATCH_QUEUE_FILTERS).reduce(
    (acc, key) => {
      acc[key] = key in matchPreferences ? matchPreferences[key] : AppConstants.MATCH_QUEUE_FILTERS[key];
      return acc;
    },
    {}
  );

  return !deepEqual(AppConstants.MATCH_QUEUE_FILTERS, filteredPreferences);
};

export const encodeData = (data) => btoa(data);

export const decodeData = (encoded) => atob(encoded);

export const getQueryParamsObj = (queryStr) => Object.fromEntries(new URLSearchParams(queryStr));
